import { Box, Typography, Container } from '@mui/material'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { LightspeedIcon } from './SystemIcons'

function PageHeader() {
  const location = useLocation()

  // Determine the current page title based on route
  const { title, showLightspeedIcon } = useMemo(() => {
    switch (location.pathname) {
      case '/':
        return {
          title: 'DASHBOARD',
          showLightspeedIcon: false
        }
      case '/lightspeed/products':
        return {
          title: 'PRODUCTS EXPORT',
          showLightspeedIcon: true
        }
      case '/lightspeed/sales':
        return {
          title: 'SALES EXPORT',
          showLightspeedIcon: true
        }
      case '/lightspeed/customers':
        return {
          title: 'CUSTOMERS EXPORT',
          showLightspeedIcon: true
        }
      case '/lightspeed/retailer-setup':
        return {
          title: 'RETAILER SETUP EXPORT',
          showLightspeedIcon: true
        }
      case '/lightspeed/bulk-sales':
        return {
          title: 'BULK SALES EXPORT',
          showLightspeedIcon: true
        }
      default:
        return {
          title: '',
          showLightspeedIcon: false
        }
    }
  }, [location.pathname])

  if (!title) return null

  return (
    <Box sx={{ bgcolor: '#f7f7f7', pt: 4, pb: 0 }}>
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
          {showLightspeedIcon && <LightspeedIcon size={32} />}
          <Typography 
            variant="h4" 
            sx={{ 
              fontWeight: 700,
              color: '#333333',
              textTransform: 'uppercase',
              letterSpacing: 0
            }}
          >
            {title}
          </Typography>
        </Box>
      </Container>
    </Box>
  )
}

export default PageHeader